
import { useEffect, useRef } from "react";
import Chartjs from "chart.js";
//-------------------------------------------
export default function Chart({ chartConfig, ...rest }){
    //-------------------------------------------------------
    const chartContainer = useRef(null);
    const myChart = useRef(null);
    //-------------------------------------------------------
    useEffect(() => {
        if(chartContainer && chartContainer.current){
            myChart.current = new Chartjs(chartContainer.current, chartConfig);
        }
        return () => {
            if(myChart.current){
                myChart.current.destroy();
            }
        }
    }, [chartConfig]);
    //-------------------------------------------------------
    return (
        <div className = "chart" style = {{width: rest.width}}>
            <canvas ref = {chartContainer} {...rest}/>
        </div>
    );
};